import React from "react";
import { formatBirthdate, formatGenderFull, formatHeight, formatWeight } from "../../../helpers/FormatHelper";
import { Patient } from "../../../models/Patient";
import {useTranslation} from "react-i18next";

interface PatientProps {
    patient: Patient;
    onClick: () => void;
    onContextMenuHandler: (anchorX: number, anchorY: number) => void;
}

export const PatientsLong: React.FC<PatientProps> = ({ patient, onClick, onContextMenuHandler }: PatientProps) => {
    const {t} = useTranslation();
    const contextMenuHandler = (event : any) => {
        event.preventDefault();
        onContextMenuHandler(event.clientX, event.clientY);
    };
    return (
        <tr onClick={onClick} onContextMenu={contextMenuHandler}>
            <td align="center">{patient.name}</td>
            <td align="center">{formatBirthdate(patient.birthDate)}</td>
            <td align="center">{patient.phone}</td>
            <td align="center">{patient.email}</td>
            <td align="center">{formatGenderFull(t, patient.gender)}</td>
            <td align="center">{formatHeight(t, patient.height, patient.heightUnits)}</td>
            <td align="center">{formatWeight(t, patient.weight, patient.weightUnits)}</td>
        </tr>
    );
}